import * as Actions from './SpaceActionTypes';

export const spaceReducer = (
  state = {
    spaceActivities: {
      fetching: false,
      error: { status: false, message: '' },
      data: []
    },
    taxes: {
      fetching: false,
      error: { status: false, message: '' },
      data: []
    },
    cancellationPolicies: {
      fetching: false,
      error: { status: false, message: '' },
      data: []
    },
    paymentOptions: {
      fetching: false,
      error: { status: false, message: '' },
      data: []
    },
    amenities: {
      fetching: false,
      error: { status: false, message: '' },
      data: []
    },
    addons: {
      fetching: false,
      error: { status: false, message: '' },
      data: []
    },
    rules: {
      fetching: false,
      error: { status: false, message: '' },
      data: []
    },
    seatingArrangement: {
      fetching: false,
      error: { status: false, message: '' },
      data: []
    },
    savings: {
      fetching: false,
      error: { status: false, message: '' },
      data: []
    },
    packageType: {
      fetching: false,
      error: { status: false, message: '' },
      data: []
    },
    newsLetter: {
      fetching: false,
      error: { status: false, message: '' },
      data: []
    },
    weeklyPicks: {
      fetching: false,
      error: { status: false, message: '' },
      data: []
    },
    mrtLocations: {
      fetching: false,
      error: { status: false, message: '' },
      data: []
    },
    spaceCategory: {
      fetching: false,
      error: { status: false, message: '' },
      data: []
    },
    pricingOptionsArray:{
      fetching: false,
      error: { status: false, message: '' },
      data: []
    }
  },
  action
) => {
  switch (action.type) {
    case Actions.FETCH_SPACE_ACTIVITIES:
      return {
        ...state,
        spaceActivities: {
          ...state.spaceActivities,
          fetching: true,
          error: { status: false, message: '' },
          isRemoveAuth: false
        }
      };

    case Actions.FETCH_SPACE_ACTIVITIES_SUCCESS:
      return {
        ...state,
        spaceActivities: {
          ...state.spaceActivities,
          fetching: false,
          error: { status: false, message: '' },
          data: action.payload
        }
      };

    case Actions.RESET_SPACE_FORM_DATA:
      return {
        ...state,
        spaceDetails: {
          ...state.spaceDetails,
          data: {
            seatArrangements: [],
          }
        }
      };

    case Actions.FETCH_SPACE_ACTIVITIES_FAILS:
      return {
        ...state,
        spaceActivities: {
          ...state.spaceActivities,
          fetching: false,
          error: { status: true, message: action.payload }
        }
      };

    case Actions.FETCH_TAX:
      return {
        ...state,
        taxes: {
          ...state.taxes,
          fetching: true,
          error: { status: false, message: '' }
        }
      };

    case Actions.FETCH_TAX_SUCCESS:
      return {
        ...state,
        taxes: {
          ...state.taxes,
          fetching: false,
          error: { status: false, message: '' },
          data: action.payload
        }
      };

    case Actions.FETCH_TAX_FAILS:
      return {
        ...state,
        taxes: {
          ...state.taxes,
          fetching: false,
          error: { status: true, message: action.payload }
        }
      };

    case Actions.FETCH_CANCELLATION_POLICIES:
      return {
        ...state,
        cancellationPolicies: {
          ...state.cancellationPolicies,
          fetching: true,
          error: { status: false, message: '' }
        }
      };

    case Actions.FETCH_CANCELLATION_POLICIES_SUCCESS:
      return {
        ...state,
        cancellationPolicies: {
          ...state.cancellationPolicies,
          fetching: false,
          error: { status: false, message: '' },
          data: action.payload
        }
      };

    case Actions.FETCH_CANCELLATION_POLICIES_FAILS:
      return {
        ...state,
        cancellationPolicies: {
          ...state.cancellationPolicies,
          fetching: false,
          error: { status: true, message: action.payload }
        }
      };

    case Actions.FETCH_PRICING_OPTIONS:
      return {
        ...state,
        paymentOptions: {
          ...state.paymentOptions,
          fetching: true,
          error: { status: false, message: '' }
        }
      };

    case Actions.FETCH_PRICING_OPTIONS_SUCCESS:
      return {
        ...state,
        paymentOptions: {
          ...state.paymentOptions,
          fetching: false,
          error: { status: false, message: '' },
          data: action.payload
        }
      };

    case Actions.FETCH_PRICING_OPTIONS_FAILS:
      return {
        ...state,
        paymentOptions: {
          ...state.paymentOptions,
          fetching: false,
          error: { status: true, message: action.payload }
        }
      };

    case Actions.FETCH_AMENITIES:
      return {
        ...state,
        amenities: {
          ...state.amenities,
          fetching: true,
          error: { status: false, message: '' }
        }
      };

    case Actions.FETCH_AMENITIES_SUCCESS:
      return {
        ...state,
        amenities: {
          ...state.amenities,
          fetching: false,
          error: { status: false, message: '' },
          data: action.payload
        }
      };

    case Actions.FETCH_AMENITIES_FAILS:
      return {
        ...state,
        amenities: {
          ...state.amenities,
          fetching: false,
          error: { status: true, message: action.payload }
        }
      };

    case Actions.FETCH_ADDONS:
      return {
        ...state,
        addons: {
          ...state.addons,
          fetching: true,
          error: { status: false, message: '' }
        }
      };

    case Actions.FETCH_ADDONS_SUCCESS:
      return {
        ...state,
        addons: {
          ...state.addons,
          fetching: false,
          error: { status: false, message: '' },
          data: action.payload
        }
      };

    case Actions.FETCH_ADDONS_FAILS:
      return {
        ...state,
        addons: {
          ...state.addons,
          fetching: false,
          error: { status: true, message: action.payload }
        }
      };

    case Actions.FETCH_RULES:
      return {
        ...state,
        rules: {
          ...state.rules,
          fetching: true,
          error: { status: false, message: '' }
        }
      };

    case Actions.FETCH_RULES_SUCCESS:
      return {
        ...state,
        rules: {
          ...state.rules,
          fetching: false,
          error: { status: false, message: '' },
          data: action.payload
        }
      };

    case Actions.FETCH_RULES_FAILS:
      return {
        ...state,
        rules: {
          ...state.rules,
          fetching: false,
          error: { status: true, message: action.payload }
        }
      };

    case Actions.FETCH_SEATING_ARRANGEMENT:
      return {
        ...state,
        seatingArrangement: {
          ...state.seatingArrangement,
          fetching: true,
          error: { status: false, message: '' }
        }
      };

    case Actions.FETCH_SEATING_ARRANGEMENT_SUCCESS:
      return {
        ...state,
        seatingArrangement: {
          ...state.seatingArrangement,
          fetching: false,
          error: { status: false, message: '' },
          data: action.payload
        }
      };

    case Actions.FETCH_SEATING_ARRANGEMENT_FAILS:
      return {
        ...state,
        seatingArrangement: {
          ...state.seatingArrangement,
          fetching: false,
          error: { status: true, message: action.payload }
        }
      };
    //e333

    case Actions.FETCH_SAVINGS:
      return {
        ...state,
        savings: {
          ...state.savings,
          fetching: true,
          error: { status: false, message: '' }
        }
      };

    case Actions.FETCH_SAVINGS_SUCCESS:
      return {
        ...state,
        savings: {
          ...state.savings,
          fetching: false,
          error: { status: false, message: '' },
          data: action.payload
        }
      };

    case Actions.FETCH_SAVINGS_FAILS:
      return {
        ...state,
        savings: {
          ...state.savings,
          fetching: false,
          error: { status: true, message: action.payload }
        }
      };
    case Actions.FETCH_SPACEDATA:
      return {
        ...state,
        spaceData: {
          ...state.spaceData,
          fetching: true,
          error: { status: false, message: '' }
        }
      };

    case Actions.FETCH_SPACEDATA_SUCCESS:
      return {
        ...state,
        spaceData: {
          ...state.spaceData,
          fetching: false,
          error: { status: false, message: '' },
          data: action.payload
        }
      };

    case Actions.FETCH_SPACEDATA_FAILS:
      return {
        ...state,
        spaceData: {
          ...state.spaceData,
          fetching: false,
          error: { status: true, message: action.payload }
        }
      };

    case Actions.FETCH_SPACEDETAILS:
      return {
        ...state,
        spaceDetails: {
          ...state.spaceDetails,
          fetching: true,
          error: { status: false, message: '' }
        }
      };

    case Actions.FETCH_SPACEDETAILS_SUCCESS:
      return {
        ...state,
        spaceDetails: {
          ...state.spaceDetails,
          fetching: false,
          error: { status: false, message: '' },
          data: action.payload
        }
      };

    case Actions.FETCH_SPACEDETAILS_FAILS:
      return {
        ...state,
        spaceDetails: {
          ...state.spaceDetails,
          fetching: false,
          error: { status: true, message: action.payload }
        }
      };

    case Actions.FETCH_PLATFORMDATA:
      return {
        ...state,
        platformData: {
          ...state.platformData,
          fetching: true,
          error: { status: false, message: '' }
        }
      };

    case Actions.FETCH_PLATFORMDATA_SUCCESS:
      return {
        ...state,
        platformData: {
          ...state.platformData,
          fetching: false,
          error: { status: false, message: '' },
          data: action.payload
        }
      };

    case Actions.FETCH_PLATFORMDATA_FAILS:
      return {
        ...state,
        platformData: {
          ...state.platformData,
          fetching: false,
          error: { status: true, message: action.payload }
        }
      };
    case Actions.FETCH_PACKAGE_TYPE:
      return {
        ...state,
        packageType: {
          ...state.packageType,
          fetching: true,
          error: { status: false, message: '' }
        }
      };

    case Actions.FETCH_PACKAGE_TYPE_SUCCESS:
      return {
        ...state,
        packageType: {
          ...state.packageType,
          fetching: false,
          error: { status: false, message: '' },
          data: action.payload
        }
      };

    case Actions.FETCH_PACKAGE_TYPE_FAILS:
      return {
        ...state,
        packageType: {
          ...state.packageType,
          fetching: false,
          error: { status: true, message: action.payload }
        }
      };
    case Actions.FETCH_FILTERSPACENAME:
      return {
        ...state,
        filterSpaceName: {
          ...state.filterSpaceName,
          fetching: true,
          error: { status: false, message: '' }
        }
      };

    case Actions.FETCH_FILTERSPACENAME_SUCCESS:
      return {
        ...state,
        filterSpaceName: {
          ...state.filterSpaceName,
          fetching: false,
          error: { status: false, message: '' },
          data: action.payload
        }
      };

    case Actions.FETCH_FILTERSPACENAME_FAILS:
      return {
        ...state,
        filterSpaceName: {
          ...state.filterSpaceName,
          fetching: false,
          error: { status: true, message: action.payload }
        }
      };

    case Actions.CLEAR_FILTERSPACENAME:
      return {
        ...state,
        filterSpaceName: {
          ...state.filterSpaceName,
          data: [],
          error: { status: false, message: '' }
        }
      };

    case Actions.CHECK_SPACE_IN_WEEKLY_PICKS:
      return {
        ...state,
        spaceWeeklyPicksCheck: {
          fetching: true,
          data: null,
          error: { status: false, message: '' }
        }
      };

    case Actions.CHECK_SPACE_IN_WEEKLY_PICKS_SUCCESS:
      return {
        ...state,
        spaceWeeklyPicksCheck: {
          fetching: false,
          data: action.payload,
          error: { status: false, message: '' }
        }
      };

    case Actions.CHECK_SPACE_IN_WEEKLY_PICKS_FAILS:
      return {
        ...state,
        spaceWeeklyPicksCheck: {
          fetching: false,
          data: null,
          error: { status: true, message: action.payload }
        }
      };

    case Actions.CLEAR_SPACE_WEEKLY_PICKS_CHECK:
      return {
        ...state,
        spaceWeeklyPicksCheck: {
          fetching: false,
          data: null,
          error: { status: false, message: '' }
        }
      };
    case Actions.FETCH_WEEKLY_PICKS:
      return {
        ...state,
        weeklyPicks: {
          ...state.weeklyPicks,
          fetching: true,
          error: { status: false, message: '' }
        }
      };
    case Actions.FETCH_WEEKLY_PICKS_SUCCESS:
      return {
        ...state,
        weeklyPicks: {
          ...state.weeklyPicks,
          fetching: false,
          error: { status: false, message: '' },
          data: action.payload.map(pickOfWeek => {
            return {
              ...pickOfWeek,
              events: []
            }
          })
        }
      };
    case Actions.FETCH_WEEKLY_PICKS_FAILS:
      return {
        ...state,
        weeklyPicks: {
          ...state.weeklyPicks,
          fetching: false,
          error: { status: true, message: action.payload }
        }
      };
    case Actions.CLEAR_SPACEDETAILS:
      return {
        ...state,
        spaceDetails: {
          ...state.spaceDetails,
          fetching: false,
          error: { status: false, message: '' },
          data: []
        }
      };
    case Actions.WEEKLYPICK_SUBMIT:
      return {
        ...state,
        weeklyPicks: {
          ...state.weeklyPicks,
          fetching: false,
          error: { status: false, message: '' },
          data: [...state.weeklyPicks.data, action.payload]
        }
      };

    case Actions.WEEKLYPICK_UPDATE:
      return {
        ...state,
        weeklyPicks: {
          ...state.weeklyPicks,
          fetching: false,
          error: { status: false, message: '' },
          data: state.weeklyPicks.data.map((space) => space.id === action.payload.id
            ? { ...space, [action?.payload?.eventTypeId ? 'eventTypeId' : 'chargingTypeId']: action?.payload.eventTypeId ? action.payload.eventTypeId : action?.payload.chargingTypeId }
            : space)
        }
      };
    case Actions.DELETE_WEEKLY_PICK:
      return {
        ...state,
        weeklyPicks: {
          ...state.weeklyPicks,
          fetching: false,
          data: state.weeklyPicks.data.filter((pick) => pick.id !== action.payload)
        }
      };

    case Actions.SAVE_WEEKLY_PICKS:
      return {
        ...state,
        weeklyPicks: {
          ...state.weeklyPicks,
          fetching: false,
          error: { status: false, message: '' }
        }
      };
    case Actions.SAVE_WEEKLY_PICKS_FAILS:
      return {
        ...state,
        weeklyPicks: {
          ...state.weeklyPicks,
          fetching: false,
          error: { status: false, message: '' }
        }
      };

    case Actions.FETCH_SPACES_STATUS:
      return {
        ...state,
        spaceStatus: {
          ...state.spaceStatus,
          fetching: true,
          error: { status: false, message: '' }
        }
      };

    case Actions.FETCH_SPACES_STATUS_SUCCESS:
      return {
        ...state,
        spaceStatus: {
          ...state.spaceStatus,
          fetching: false,
          error: { status: false, message: '' },
          data: action.payload
        }
      };

    case Actions.FETCH_SPACES_STATUS_FAILS:
      return {
        ...state,
        spaceStatus: {
          ...state.spaceStatus,
          fetching: false,
          error: { status: true, message: action.payload }
        }
      };

    case Actions.FETCH_SPACESTATUSDATA:
      return {
        ...state,
        spaceData: {
          ...state.spaceData,
          fetching: true,
          error: { status: false, message: '' }
        }
      };

    case Actions.FETCH_SPACESTATUSDATA_SUCCESS:
      return {
        ...state,
        spaceData: {
          ...state.spaceData,
          fetching: false,
          error: { status: false, message: '' },
          data: action.payload
        }
      };

    case Actions.FETCH_SPACESTATUSDATA_FAILS:
      return {
        ...state,
        spaceData: {
          ...state.spaceData,
          fetching: false,
          error: { status: true, message: action.payload }
        }
      };

    case Actions.FETCH_SPACECOUNTRYDATA:
      return {
        ...state,
        spaceData: {
          ...state.spaceData,
          fetching: true,
          error: { status: false, message: '' }
        }
      };

    case Actions.FETCH_SPACECOUNTRYDATA_SUCCESS:
      return {
        ...state,
        spaceData: {
          ...state.spaceData,
          fetching: false,
          error: { status: false, message: '' },
          data: action.payload
        }
      };

    case Actions.FETCH_SPACECOUNTRYDATA_FAILS:
      return {
        ...state,
        spaceData: {
          ...state.spaceData,
          fetching: false,
          error: { status: true, message: action.payload }
        }
      };

    case Actions.FETCH_MRT_LOCATIONS:
      return {
        ...state,
        mrtLocations: {
          ...state.mrtLocations,
          fetching: true,
          error: { status: false, message: '' },
        }
      };

    case Actions.FETCH_MRT_LOCATIONS_SUCCESS:
      return {
        ...state,
        mrtLocations: {
          ...state.mrtLocations,
          fetching: false,
          error: { status: false, message: '' },
          data: action.payload
        }
      };

    case Actions.FETCH_MRT_LOCATIONS_FAILS:
      return {
        ...state,
        mrtLocations: {
          ...state.mrtLocations,
          fetching: false,
          error: { status: true, message: action.payload }
        }
      };

    case Actions.FETCH_SPACE_CATEGORY:
      return {
        ...state,
        spaceCategory: {
          ...state.spaceCategory,
          fetching: true,
          error: { status: false, message: '' },
        }
      };

    case Actions.FETCH_SPACE_CATEGORY_SUCCESS:
      return {
        ...state,
        spaceCategory: {
          ...state.spaceCategory,
          fetching: false,
          error: { status: false, message: '' },
          data: action.payload
        }
      };

    case Actions.FETCH_SPACE_CATEGORY_FAILS:
      return {
        ...state,
        spaceCategory: {
          ...state.spaceCategory,
          fetching: false,
          error: { status: true, message: action.payload }
        }
      };

    case Actions.FETCH_PRICING_OPTIONS_DAYS_ARRAY:
      return {
        ...state,
        pricingOptionsArray:{
          ...state.pricingOptionsArray,
          fetching: true,
        }
        
      };

    case Actions.FETCH_PRICING_OPTIONS_DAYS_ARRAY_SUCCESS:
      return {
        ...state,
        pricingOptionsArray:{
          ...state.pricingOptionsArray,
          fetching: false,
          data: action.payload
        }
        
      };
    case Actions.FETCH_PRICING_OPTIONS_DAYS_ARRAY_FAILS:
      return {
        ...state,
        pricingOptionsArray:{
          ...state.pricingOptionsArray,
          fetching: false,
          pricingOptionsArray:[]
        }
      };
    case Actions.FETCH_SPACES_BY_FILTER:
      return {
        ...state,
        spacesByFilter: {
          ...state.spacesByFilter,
          loading: true,
          error: null
        }
      };

    case Actions.FETCH_SPACES_BY_FILTER_SUCCESS:
      return {
        ...state,
        spacesByFilter: {
          loading: false,
          data: action.payload,
          error: null
        }
      };

    case Actions.FETCH_SPACES_BY_FILTER_FAILS:
      return {
        ...state,
        spacesByFilter: {
          loading: false,
          data: [],
          error: action.payload
        }
      };
    default:
      return state;
  }
};
